import { render, staticRenderFns } from "./folienabnahme-rueckmeldung.vue?vue&type=template&id=85340c00&scoped=true&"
import script from "./folienabnahme-rueckmeldung.vue?vue&type=script&lang=js&"
export * from "./folienabnahme-rueckmeldung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85340c00",
  null
  
)

export default component.exports